import * as styles from './NumberInput.module.css'

import React from 'react'
import classNames from 'classnames'

interface Props extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {
  accent?: boolean
  unit?: string
}

export const NumberInput: React.FC<Props> = (props) => {
  const { accent, unit, ...inputProps } = props

  return (
    <div className={styles.container}>
      <input
        type="number"
        {...inputProps}
        className={classNames(styles.input, {
          [styles.accent]: accent,
          [styles.withUnit]: unit != null,
        })}
      />
      {unit != null && <div className={styles.unit}>{unit}</div>}
    </div>
  )
}
